<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Total Hs CT" :xl="xl">
                    <strong>{{ item.campoLivre1 }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Saldo Hs Ant" :xl="xl">
                    <strong>{{ item.campoLivre2 }}</strong>
                </app-detalhe>
                
            </b-col>
        </b-row>
  </div>
</template>

<script>

export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        },
    },
    
    data() {
        return {
            xl: 2,
        }
    },

    methods: {
    },

    created() {
    },
}

</script>

<style>

</style>